import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GatedFeature } from '../../features/admin/models/team.interface';

/**
 * Functional guard to protect routes by resolved user capability. Resolution (and the
 * SUPER_ADMIN bypass) lives in {@link AuthService.hasCapability}, the single source of truth.
 */
export const capabilityGuard = async (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.currentUser()) {
    await authService.resolveUserFromSession();
  }

  const requiredCap = route.data['requiredCapability'] as GatedFeature | undefined;
  if (!requiredCap) {
    return true;
  }

  return authService.hasCapability(requiredCap) ? true : router.createUrlTree(['/main/dashboard']);
};
